import React, { useCallback, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ArrowLeft, Users } from "@phosphor-icons/react";
import api from "../lib/api";

const fmt = (n) => (n || 0).toLocaleString();

export default function Communities() {
  const nav = useNavigate();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/communities");
      setItems(data.communities || []);
    } catch (err) {
      console.error("communities load failed", err);
    } finally { setLoading(false); }
  }, []);

  useEffect(() => { load(); }, [load]);

  return (
    <div className="min-h-[100dvh] bg-ink pb-32">
      <header className="sticky top-0 z-30 crystal-glass px-5 pt-6 pb-4">
        <div className="flex items-center gap-3">
          <button onClick={() => nav(-1)} data-testid="communities-back" className="w-9 h-9 rounded-full bg-white/5 flex items-center justify-center text-cream">
            <ArrowLeft size={18} />
          </button>
          <div>
            <p className="text-papaya text-[10px] tracking-[0.3em] uppercase font-bold">Culture-first</p>
            <h1 className="text-cream text-2xl font-black tracking-tighter">Communities</h1>
          </div>
        </div>
      </header>

      <section className="px-4 mt-5" data-testid="communities-grid">
        {loading ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            {[0, 1, 2, 3].map((i) => <div key={i} className="h-40 rounded-3xl bg-white/5 animate-pulse" />)}
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            {items.map((c) => (
              <Link
                key={c.slug}
                to={`/c/${c.slug}`}
                data-testid={`community-card-${c.slug}`}
                className="group relative h-40 rounded-3xl overflow-hidden border border-white/10 hover:border-papaya/60 transition-colors"
              >
                <img src={c.cover} alt="" className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/75 to-ink/20" />
                <div className="absolute inset-x-0 bottom-0 p-4">
                  <p className="text-cream text-lg font-black tracking-tight">{c.emoji} {c.name}</p>
                  <p className="text-cream/70 text-xs">{c.tagline}</p>
                  <div className="mt-2 flex items-center gap-3 text-[11px] font-bold">
                    <span className="text-papaya flex items-center gap-1"><Users size={13} weight="fill" /> {fmt(c.member_count)}</span>
                    <span className="text-cream/60">{fmt(c.post_count)} posts</span>
                    <span className="text-cream/60">{fmt(c.creator_count)} creators</span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
